<template>
    <section
        id="control-center"
        class="control-center"
        :class="{ collapsed: isControlCenterCollapsed }"
    >
        <header
            class="control-center__header"
            @click="isControlCenterCollapsed = !isControlCenterCollapsed"
        >
            <div class="control-center__header-title">
                <img
                    src="/images/map/control-center.svg"
                    alt="Control Center"
                />
                <h1>Control Center</h1>
                <span
                    :class="{
                        'icon-chevron-up': !isControlCenterCollapsed,
                        'icon-chevron-down': isControlCenterCollapsed,
                    }"
                />
            </div>

            <div>
                <img
                    src="/images/settings.svg"
                    alt="Open settings"
                    @click.stop="$emit('toggleSettingsDisplay')"
                />
            </div>
        </header>

        <icon-picker
            v-if="selectedItem"
            class="control-center__icon-picker"
            :selectedItem="selectedItem"
            :selectedTarget="selectedTarget"
            @deselectItem="selectedItem = null"
        />

        <section class="map-items-selector">
            <ul>
                <li
                    :class="{ active: activeList === 'users' }"
                    @click="activeList = 'users'"
                >
                    Users
                </li>
                <!-- <li
                    :class="{ active: activeList === 'groups' }"
                    @click="activeList = 'groups'"
                >
                    Groups
                </li> -->
                <li
                    :class="{ active: activeList === 'objects' }"
                    @click="activeList = 'objects'"
                >
                    Objects
                </li>
            </ul>
        </section>

        <div class="map-items-container">
            <div class="map-items-scrollable">
                <user-locations
                    class="map-items"
                    :class="{ active: activeList === 'users' }"
                    :userLocations="userLocations"
                    :clearMapObject="confirmClearMapObjectFor('user_locations')"
                    @selectUserLocation="selectItemForIconPicker"
                />

                <!-- <groups
                    class="map-items"
                    :class="{ active: activeList === 'groups' }"
                    :groups="groups"
                    :clearMapObject="confirmClearMapObjectFor('groups')"
                    @selectGroup="selectItemForIconPicker"
                /> -->

                <objects
                    class="map-items"
                    :class="{ active: activeList === 'objects' }"
                    :pins="pins"
                    :shapes="shapes"
                    :confirmClearMapObjectFor="confirmClearMapObjectFor"
                />
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'
import IconPicker from './IconPicker.vue'
import UserLocations from './UserLocations.vue'
// import Groups from './Groups.vue'
import Objects from './Objects.vue'

export default {
    components: {
        IconPicker,
        UserLocations,
        // Groups,
        Objects,
    },

    props: {
        userLocations: {
            type: Array,
            required: true,
        },

        // groups: {
        //     type: Array,
        //     required: true,
        // },

        pins: {
            type: Array,
            required: true,
        },

        shapes: {
            type: Array,
            required: true,
        },

        confirmClearMapObjectFor: {
            type: Function,
            required: true,
        },
    },

    data() {
        return {
            activeList: 'users',
            isControlCenterCollapsed: false,
            selectedItem: null,
            selectedTarget: null,
        }
    },

    computed: {
        ...mapGetters(['organization']),

        visiblePliCount() {
            return this.userLocations.filter((u) => u.isVisible()).length
        },
    },

    mounted() {
        // NOTE: root event emitting/receiving will be deprecated in Vue 3
        this.$eventBus.on('displayStaleUsers', () => {
            this.activeList = 'users'
        })
    },

    methods: {
        selectItemForIconPicker(event, item) {
            this.selectedTarget = event.target
            this.selectedItem = item
        },
    },
}
</script>
